module.exports = __webpack_public_path__ + "static/media/ProximaNovaT-Thin.c8516677.eot";